import ApiService from "../api";

export default class FluigDespesaService extends ApiService {

    constructor() {
        super(`/api/fluig/despesas`);
    }

    relatorioDespesas(dataInicial, dataFinal, solicitante, departamento, status, filial) {

        const params = new URLSearchParams();

        if (dataInicial) params.append("dataInicial", dataInicial);
        if (dataFinal) params.append("dataFinal", dataFinal);
        if (solicitante) params.append("solicitante", solicitante);
        if (departamento) params.append("departamento", departamento);
        if (status) params.append("status", status);
        if (filial) params.append("filial", filial);

        return this.get(`/?${params.toString()}`);
    }

    exportarExcel(dataInicial, dataFinal, solicitante, departamento, status, filial) {
        var params = `/exportar?dataInicial=${dataInicial}&dataFinal=${dataFinal}`
        
        if (solicitante){params += "&solicitante=" + solicitante}
        if (departamento){ params += "&departamento=" + departamento}
        if (status){params += "&status=" + status}
        if (filial){   params += "&filial=" + filial}
    
        return this.getFile(params);
    }

    sincronismoManual() {
        return this.get(`/sincronismo`);
    }
}
